import { render, staticRenderFns } from "./AnswerColumns2.vue?vue&type=template&id=18556c08&scoped=true&"
import script from "./AnswerColumns2.vue?vue&type=script&lang=js&"
export * from "./AnswerColumns2.vue?vue&type=script&lang=js&"
import style0 from "./AnswerColumns2.vue?vue&type=style&index=0&id=18556c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18556c08",
  null
  
)

export default component.exports